module.exports = __webpack_public_path__ + "img/zdcyl_bg2.072b449d.png";